import { initializeApp } from "firebase/app";
import { browserLocalPersistence, getAuth, indexedDBLocalPersistence, setPersistence, signInWithCustomToken, inMemoryPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(app);
export const firebaseSignInWithToken = signInWithCustomToken;
export const db = getFirestore();

let initPromise: Promise<string> | null = null;

export function initAuthPersistence(): Promise<string> {
  // console.log("[firebase] apps", getApps().map(a => ({ name: a.name, apiKey: a.options.apiKey })));
  // console.log("[firebase] auth.app", getAuth().app.name);

  if (!initPromise) {
    initPromise = (async () => {
      try {
        await setPersistence(firebaseAuth, indexedDBLocalPersistence);
        // console.log('[auth] persistence = indexedDB');
        return 'indexedDB';
      } catch (e1) {
        // console.warn('[auth] indexedDB persistence failed, trying localStorage', e1);
      }

      try {
        await setPersistence(firebaseAuth, browserLocalPersistence);
        // console.log('[auth] persistence = localStorage');
        return 'localStorage';
      } catch (e2) {
        // console.warn('[auth] localStorage persistence failed, falling back to session', e2);
      }

      // Could mess things up
      // try {
      //   await setPersistence(firebaseAuth, browserSessionPersistence);
      //   return 'session';
      // } catch { }

      await setPersistence(firebaseAuth, inMemoryPersistence);
      return 'memory';

      // console.log('[auth] persistence = session');
    })();
  }
  return initPromise;
}
